import _ from 'lodash';
import challengeDetails from './challenge-details';
import memberProfile from './profile';

export default _.merge({}, challengeDetails, memberProfile);
